module.exports = __webpack_public_path__ + "img/1RAHH-DF.8ee64a9d.png";